import { formatPrice } from "Components/Merchant/Initiate/InitiatePaymentKeypad/utils";
import { PrimaryButton } from "Components/Shared/Buttons/PrimaryButton";
import type { CurrencyCode } from "Models/CurrencyCodes";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  onPay: (price: number) => void;
  priceInCents: number;
  currencyCode: CurrencyCode | undefined;
  isDisabled?: boolean;
};

export const InitiatePaymentButton = ({
  onPay,
  priceInCents,
  currencyCode,
  isDisabled,
}: Props) => {
  const { t } = useResource();
  const createPayment = () => onPay(priceInCents / 100);

  return (
    <PrimaryButton
      fullWidth
      variant="contained"
      color="primary"
      sx={{ textTransform: "none", lineBreak: "anywhere" }}
      disabled={isDisabled}
      onClick={createPayment}
    >
      {t(Resources.Merchant.Payment.InitiateKeypadPaymentButton, {
        amount: formatPrice(priceInCents, currencyCode),
      })}
    </PrimaryButton>
  );
};
